import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().min(1),
  VITE_SUPABASE_URL: z.string().min(1),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_DISABLE_GUARDS: z.string().default('false'),
  VITE_USE_MOCK: z.string().default('false'),
  VITE_AUTH_PROVIDER: z.enum(['supabase', 'firebase', 'api']).optional(),
  VITE_FIREBASE_API_KEY: z.string().optional(),
  VITE_FIREBASE_PROJECT_ID: z.string().optional(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SIGNALR_HUB_URL: z.string().optional(),
  VITE_SYNCFUSION_LICENSE_KEY: z.string().optional(),
});

const result = envSchema.safeParse(import.meta.env);

if (!result.success) {
  const issues = result.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n');
  throw new Error(`[env] Missing or invalid environment variables:\n${issues}`);
}

export const env = result.data;
export type Env = z.infer<typeof envSchema>;

export const isDev: boolean = import.meta.env.DEV;
export const buildMode: string = import.meta.env.MODE;
